//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
import { has } from "lodash";
import axios from "axios"
//  -- Actions ------------------------
import { logToSentry } from "utils/networkErrorUtils";
import * as SuperLessonActions from './actions';
import configInfo from "config"
import { getAwsAuthToken } from 'utils/lib/authHelper';
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create Super Lesson --------------------

export const handleCreateSuperLesson = (data) => async (dispatch) => {
    // await dispatch(SuperLessonActions.createVocabulary());
    try {
        const lessonData = await apis.post('super_lesson', `/create`, {
            body: data
        });
        if (data.id) {
            await dispatch(SuperLessonActions.updateLessonSuccess(lessonData));
        } else {
            await dispatch(SuperLessonActions.createLessonSuccess(lessonData));
        }
        return lessonData
    } catch (error) {
        if (error && error.message !== "Network Error") {
            logToSentry({
                message: 'creating super lesson',
                error,
                module: 'SUPER_LESSON',
                operation: 'CREATE_SUPER_LESSON'
            });
        }
    }
};


export const handleGetSuperLesson = (data) => async (dispatch) => {
    try {
        const lessonData = await apis.post('super_lesson', `/list`, {
            body: data
        });
        const normalizedLessonData = Array.isArray(lessonData)
            ? lessonData
            : Array.isArray(lessonData?.data)
                ? lessonData.data
                : [];
        await dispatch(SuperLessonActions.listLessonSuccess(normalizedLessonData));
        return normalizedLessonData;
    } catch (error) {
        if (error) {
            logToSentry({
                message: 'listing super lesson',
                error,
                module: 'SUPER_LESSON',
                operation: 'LIST_SUPER_LESSON'
            });
            return null;
        }
    }
};

//  -- Delete Book vocabulary ----------
export const handleDeleteSuperLesson = (id) => async (dispatch) => {
    if (!id) return;
    // dispatch(SuperLessonActions.deleteVocabulary())
    try {
        const vocabulary = await apis.del('super_lesson', `/delete/${id}`);
        if (has(vocabulary, "id")) {
            await dispatch(SuperLessonActions.deleteLessonSuccess(vocabulary));
        }
    } catch (error) {
        if (error && error.message !== "Network Error") {
            logToSentry({
                message: 'deleting super lesson',
                error,
                module: 'SUPER_LESSON',
                operation: 'DELETE_SUPER_LESSON'
            });
        }
    }
};
export const handleUpdateSuperlession = (id, content,language) => async (dispatch) => {
    if (!id) return;
    try {
        const superlession = await apis.post('super_lesson', `/updateContent`,{
            body:{
                id,content,language
            }
        });
        if (superlession && superlession.success) {
            await dispatch(SuperLessonActions.updateLessonSuccess(superlession.data));
        }
        return superlession;
    } catch (error) {
        if (error && error.message !== "Network Error") {
            logToSentry({
                message: 'updating super lesson',
                error,
                module: 'SUPER_LESSON',
                operation: 'UPDATE_SUPER_LESSON'
            });
        }
    }
    return null;
};

export const handleLanguageTranslator =  (id) => async (dispatch) => {
    try{
        const token = await getAwsAuthToken();
        const prodUrl = `${configInfo.apiGateway.AI_BASE_NODE_URL}/SuperLessonStream/super-lesson-english-converter`;
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: prodUrl,
            headers: {
                'Content-Type': 'application/json',
                 'Authorization': `Bearer ${token}`,
                  "x-auth-source": configInfo.isDev ? "test" : "prod",
            },
            data: {lessonId: id, mode: import.meta.env.VITE_APP_STAGE?.trim() === "prod" ? "prod" : "dev" }
        };

        const response = await axios.request(config);
        await dispatch(SuperLessonActions.updateLessonSuccess({id: response.data?.data?.lessonId, english_content: response.data?.data?.english_content}));
        return response;
    }catch(error){
        logToSentry({
                message: 'Error in operation',
                error,
                module: 'SUPER_LESSON',
                operation: 'CREATE_SUPER_LESSON'
            });
    }
}
